import { SxProps, Theme } from "@mui/material";
import colorsConstants from "src/app/constants/colors.constants";

const styles = {
  parent: {
    backgroundColor: colorsConstants.mainContentBackgroundColor,
    flex: 1,
    display: "flex",
    height: "100vh",
  },
  drawerAwareContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    padding: "24px",
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
  },
  titleText: {
    color: colorsConstants.primaryText,
    fontSize: 24,
    textAlign: "center",
    flex: 1,
  },
  selectedTab: {},
  calendarContainer: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    minHeight: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    boxShadow: "none",
  },
  selectedTabContent: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    height: "100%",
    boxShadow: "none",
  },
  selectedTabText: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
    mb: 2,
  },
  searchingLoader: {
    display: "flex",
    justifyContent: "center",
    py: 4,
  },
  noUsersText: {
    color: colorsConstants.primaryText,
    opacity: 0.7,
  },
  requesterNameText: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
    mb: 0.5,
  },
  requesterDate: {
    color: colorsConstants.primaryText,
    mb: 0.5,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
